import { render, staticRenderFns } from "./XDLocalStorageIframe.vue?vue&type=template&id=4e542b2f&"
import script from "./XDLocalStorageIframe.vue?vue&type=script&lang=js&"
export * from "./XDLocalStorageIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports